<template>
  <div class="status-page-wrapper">
    <Breadcrumbs main="" title="Status Page" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
            <div class="status-page-header">
              <!-- Search Bar Row -->
              <b-row class="mb-3">
                <b-col md="4">
                  <div class="status-page-search-wrapper">
                    <b-input-group>
                      <b-input-group-prepend>
                        <span class="input-group-text search-icon">
                          <i class="icofont icofont-search-alt-2"></i>
                        </span>
                      </b-input-group-prepend>
                      <b-form-input
                        class="status-page-search-input"
                        v-model="filter"
                        placeholder="Search"
                        type="search"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col md="8" class="d-flex justify-content-end align-items-center">
                  <div class="status-page-per-page-wrapper">
                    <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span>Per page : </span>
                    <div class="select-wrapper">
                      <b-form-select
                        class="status-page-per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="getAllStatus"
                      >
                      </b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                  <button class="status-page-add-btn ml-3" @click="add_status_modal = true">
                    <img src="@/assets/icons/add-statuspage.svg" alt="Add Status Page" class="add-status-icon" />
                    Add Status Page
                  </button>
                  <add-monitor-button 
                    class="ml-3" 
                    :icon-only="true" 
                    variant="green"
                  />
                </b-col>
              </b-row>
            </div>
              <div class="col-md-12" v-if="loading">
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <div v-else class="status-page-table-container">
                <b-table
                  class="status-page-table"
                  show-empty
                  stacked="md"
                  :items="items"
                  :filter="filter"
                  :fields="tablefields"
                  :per-page="perPage"
                  @filtered="onFiltered"
                  borderless
                >
                <template #cell(index)="data">
                  <span class="status-sr-number">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
                </template>

                <template #cell(name)="data">
                  <a :href="statusPageurl+data.item._id" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     class="status-page-name" 
                     :title="data.item.name">
                    {{ data.item.name }}
                  </a>
                </template>
                <template #cell(pagePassword)="data">
                  <span>{{ data.item.pagePassword ? '************' : 'No password' }}</span>
                </template>
                <template #cell(monitors)="data">
                  <span>{{ data.item.monitors ? data.item.monitors.length : 0 }}</span>
                </template>
                <template #cell(createdAt)="data">
                  <span>{{ changeDateFormate(data.item.createdAt) }}</span>
                </template>
                
                <template #cell(status)="data">
                    <div class="status-toggle">
                        <label class="switch">
                        <input type="checkbox" :checked=data.item.status @change="statusUpdate(data.item)">
                        <span class="switch-state" :class="data.item.status?'status-active':'status-inactive'"></span>
                        </label>
                    </div>                 
                </template>
                <template #cell(action)="data">
                  <div class="action-buttons">
                    <button class="action-btn" @click="deleteStatus(data.item._id)" title="Delete">
                      <img src="@/assets/icons/delete-icon.svg" alt="Delete" class="action-icon" />
                    </button>
                    <button class="action-btn" @click="editStatus(data.item)" title="Edit">
                      <img src="@/assets/icons/edit-icon.svg" alt="Edit" class="action-icon" />
                    </button>
                    <a :href="statusPageurl+data.item._id" target="_blank" title="View Status Page" rel="noopener noreferrer" class="action-btn">
                      <img src="@/assets/icons/view-modal-icon.svg" alt="View" class="action-icon" />
                    </a>
                  </div>
                </template> 
                </b-table>
                <!-- Pagination Component -->
                <div class="pagination-wrapper">
                  <pagination-component
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount || totalRows"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
                </div>
              </div>
        </div>
      </div>
    </div>
    <b-modal id="status-monitor" size="lg" @hidden="closeModal()" title="" class="theme-modal custom-modal" v-model="add_status_modal" no-close-on-backdrop hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">{{ edit_status ? 'Edit Status Page' : 'Create Status Page' }}</h5>
            <button class="custom-modal-close" @click="closeModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <add-status-page @statusmodal="closeModal" :add_status_modal="add_status_modal" :edit_status="edit_status" :status_data="status_data"></add-status-page>
        <!-- No footer -->
    </b-modal>
  </div>
</template>



<script>
import moment from 'moment'
import AddStatusPage from './AddStatusPage.vue';
import StatusPageController from "../../services/statuspageController";
import Config from "../../services/config"
import AddMonitorButton from ".././components/addMonitorButton.vue";
import PaginationComponent from "../components/PaginationComponent.vue";
export default{
  components: { AddStatusPage, AddMonitorButton, PaginationComponent },
    name:'StatusPage',
    data(){
        return{
            add_status_modal:false,
            items:[],
            totalRows:0,
            perPage: 10,
            pageOptions: [5, 10, 50],
            currentPage: 1,
            filter:null,
            edit_status:false,
            loading: false,
            totalRowsCount: 0,
            tablefields:[
              { key: "index", label: "Sr", sortable: false },
              { key: "name", label: "Name", sortable: true },
              { key: "pagePassword", label: "Page password", sortable: false },
              { key: "monitors", label: "Monitors", sortable: false },
              { key: "createdAt", label: "Created At", sortable: true },
              { key: "status", label: "Status", sortable: false },
              { key: "action", label: "Action", sortable: false },
            ],
            status_data:{},
            statusPageurl:'',
            btn_class:''
        }
    },
    mounted(){
      this.statusPageurl = Config.statusPageUrl
      this.getAllStatus()

      let pathName = this.$route.name
      if (pathName === 'Dashboard' || pathName === 'Incidents' || pathName === 'SubUser' || pathName === 'Profile') {
          this.btn_class = 'custom-btn-dark';
      } else {
          this.btn_class = 'add-monitor-btn-green';
      }
    },
    methods:{
      closeModal(){
          this.add_status_modal = false
          this.edit_status = false;
          this.getAllStatus();
        },
      async getAllStatus(){
        this.loading = true;
        this.items = []
        let paginationQuery = '?currentPage='+this.currentPage+'&pageSize='+this.perPage

        let response = await StatusPageController.getAll(paginationQuery)
        console.log('StatusPage API Response:', response); // Debug log
        if (response.result) {
            this.items = response.data;
            this.totalRows = this.items.length;
            // Use the total count from API, or if not available, don't limit to current page items
            this.totalRowsCount = response.totalCount || response.total || response.count || 0;
            
            // If API doesn't return total count and we have a full page, assume there might be more
            if (!this.totalRowsCount && this.items.length === this.perPage) {
                // Set a high number to enable next button
                this.totalRowsCount = this.currentPage * this.perPage + 1;
            } else if (!this.totalRowsCount) {
                // If less than perPage items, this is likely the last page
                this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.items.length;
            }
        }
        this.loading = false;
      },
      handlePageChange(page) {
        if (page === 'next') {
          this.currentPage++;
        } else if (page === 'prev' && this.currentPage > 1) {
          this.currentPage--;
        }
        this.getAllStatus();
      },
      handlePerPageChange(value) {
        this.perPage = value;
        this.currentPage = 1;
        this.getAllStatus();
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async deleteStatus(id){
        if(confirm('Are you sure to delete this status?')){
        let response = await StatusPageController.deleteStatus({"spid": id});
          if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            this.getAllStatus()
          }
          else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
          }
      }
      },
      changeDateFormate(d){
          return moment(d).format('D/M/YYYY, hh:mm A')
      },
      editStatus(data){
          this.add_status_modal = false
          this.add_status_modal = true
          this.status_data = data;
          this.edit_status = true;
      },
      async statusUpdate(data){
        // this.loading = true;
        var s = true
        if(data.status == true){
            s = false
        }
        if (data.status == false) {
          data.status = true;
        } else {
          data.status = false;
        }
        var payload = {"spid": data._id, "changePayload": {"status":s}}
        let response = await StatusPageController.updateStatusPage(payload)
        if(response.result){
          let toastMessage = data.status ? "Activated successfully" : "Deactivated successfully";
          this.$toasted.show(toastMessage || response.message, { 
              theme: 'outline', 
              position: "bottom-center", 
              type: 'success', 
              duration: 2000 
          });
        }
        else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
            this.getAllStatus()
        }
      },
  }
}
</script>

<style scoped>
/* Main wrapper */
.status-page-wrapper {
  padding: 0;
}

/* Header styling */
.status-page-header {
  margin-bottom: 20px;
  margin-top: 30px;
  width: 100%;
}

/* Search input styling */
.status-page-search-wrapper {
  position: relative;
}

.status-page-search-wrapper .input-group {
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  padding: 0px;
}

.status-page-search-wrapper .input-group-text {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px;
}

.status-page-search-wrapper .search-icon {
  color: #344054;
  font-size: 18px;
}

.status-page-search-input {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px 3px 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #111827;
}

.status-page-search-input:focus {
  box-shadow: none;
  background: transparent;
}

.status-page-search-input::placeholder {
  color: #9CA3AF;
}

/* Per page selector styling */
.status-page-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 47px;
}

.status-page-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.status-page-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.status-page-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.status-page-per-page-select:focus {
  box-shadow: none;
  outline: none;
}

.status-page-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

/* Add Status Page button */
.status-page-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background: #2FB234;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 48px;
}

.status-page-add-btn:hover {
  background: #28A22C;
}

.add-status-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

/* Table container */
.status-page-table-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  overflow: hidden;
  margin: 0 0 20px 0;
  width: 100%;
}

/* Table styling */
.status-page-table {
  margin-bottom: 0;
  width: 100%;
  border: none !important;
  border-radius: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: visible;
}

.status-page-table >>> thead th {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px!important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

/* Center align the Action column header */
.status-page-table >>> thead th:last-child {
  text-align: center !important;
}

.status-page-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #161616;
  vertical-align: middle;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

/* Serial number */
.status-sr-number {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}

/* Status page name - clickable link */
.status-page-name {
  font-weight: 500;
  color: #0B6CFA;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  text-decoration: none;
}

.status-page-name:hover {
  text-decoration: underline;
  color: #0B6CFA;
}


/* Status toggle */
.status-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.status-toggle .switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.status-toggle .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.status-toggle .switch-state {
  position: absolute;
  cursor: pointer;
  top: 75%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 24px;
  transition: .4s;
  border-radius: 34px;
}

.status-toggle .switch-state:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

.status-toggle input:not(:checked) + .switch-state {
  background-color: #E5E7EB !important;
}

.status-toggle input:checked + .switch-state {
  background-color: #10B981 !important;
}

.status-toggle input:checked + .switch-state:before {
  transform: translateX(20px);
}

/* Action buttons */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 4px;
  text-decoration: none;
}

.action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.action-icon {
  width: 20px;
  height: 20px;
}

/* Pagination wrapper */
.status-page-table-container .pagination-wrapper {
  background: #FFFFFF;
  border-radius: 0 0 20px 20px;
  padding: 0;
  border-top: none !important;
}

/* Remove any top border from pagination component and its children */
.status-page-table-container .pagination-wrapper > *,
.status-page-table-container .pagination-wrapper .custom-pagination {
  border-top: none !important;
  margin-top: 0 !important;
}

/* Loader */
.loader-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Empty state */
.status-page-table .b-table-empty-row td {
  text-align: center;
  padding: 60px 20px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #6B7280;
}

/* Custom Modal Styles */
.custom-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.custom-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 26px;
  color: #3A3A3A;
  margin: 0;
  text-align: center;
}

.custom-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.custom-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.custom-modal .modal-body {
  padding: 30px;
  font-family: 'Poppins', sans-serif;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .status-page-header > .row > .col-md-4,
  .status-page-header > .row > .col-md-8 {
    margin-bottom: 16px;
  }

  .status-page-header .col-md-8 {
    flex-direction: column;
    align-items: stretch !important;
  }

  .status-page-per-page-wrapper {
    justify-content: center;
    margin-bottom: 12px;
  }

  .status-page-add-btn {
    width: 100%;
    justify-content: center;
  }

  .status-page-table tbody td {
    padding: 16px 20px;
    font-size: 14px;
  }

  .action-buttons {
    justify-content: flex-start;
  }
}
</style>